import { Evaluation } from "../Form-image/Evaluation.js";
const evaluation = new Evaluation();
window.evaluation = evaluation;

import { Subscription } from "../Mailing/Subscription.js";
const subscription = new Subscription();
window.subscription = subscription;

import { Application } from "../popup/Application.js";
const application = new Application();
window.application = application;

import { FAQ } from "../FAQ/FAQ.js";
const faq = new FAQ();
window.faq = faq;

import { Blog } from "../Blog/Blog.js";
const blog = new Blog();
window.blog = blog;


// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

if (isTouchDevice()) {
	$("body").removeClass("des");
	$("body").addClass("mob");
} else {
	$("body").removeClass("mob");
	$("body").addClass("des");
}

const header = document.querySelector(".header");

const appHeights = () => {
	const doc = document.documentElement
	let headerHeight = $('.header').outerHeight();
	let windowHeight = $(window).height();
	doc.style.setProperty('--app-height', windowHeight + "px");
	doc.style.setProperty('--header-height', headerHeight + "px");
}
appHeights();


// Burger
$(".main-nav__toggler").on("click", function () {
	$(this).toggleClass("active");
	$(".main-nav__list").toggleClass("active");
});


// Header services
$(".main-nav__services-toggler").on("click", function () {
	if (!window.matchMedia("(min-width: 1024px)").matches) {
		$(this).toggleClass("active");
		$(".header__services").slideToggle();
	} else {
		$(".header__services").toggleClass("active");
	}
});


// Header tel click
$(".header__tel").on("click", function () {
	if (window.hasOwnProperty('yaCounter87397587'))
		yaCounter87397587.reachGoal('ClickToCallTop')
});


// Open popup application
$(".open-popup-application").on("click", function () {
	let dataPopupApplicationFrom = $(this).attr("data-popup-application-from");
	$(".popup-application__input-from").val(dataPopupApplicationFrom);
});


// Service constructor card link click
$(".service-constructor__card-link").on("click", function () {
	if (window.hasOwnProperty('yaCounter87397587'))
		yaCounter87397587.reachGoal('ToConstruct')
});


// Resize
$(window).on("resize", function () {
	// is touch
	isTouchDevice();

	// app heights
	appHeights();

	// Header services
	if ($(".main-nav__services-toggler").hasClass("active") && window.matchMedia("(min-width: 1024px)").matches) {
		$(".main-nav__services-toggler").removeClass("active");
		$(".header__services").removeAttr("style");
	}
});


// Scroll
$(window).on("scroll", function () {
	// app heights
	appHeights();
})


// Document click
$(document).on("click", function (e) {
	// Header nav
	if ($(".main-nav__toggler").hasClass("active") && !window.matchMedia("(min-width: 1024px)").matches) {
		var callbackPopup = $(".main-nav__toggler, .main-nav__list");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".main-nav__toggler").removeClass("active");
			$(".main-nav__list").removeClass("active");
		};
	}

	// Header services
	if ($(".header__services").hasClass("active")) {
		var callbackPopup = $(".main-nav__services-toggler, .header__services");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__services").removeClass("active");
		};
	}

	// Article share
	if ($(".article__share-list").hasClass("active")) {
		var callbackPopup = $(".article__share-toggler, .article__share-list");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".article__share-list").removeClass("active");
		};
	}
});


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
		if ($(this).hasClass("popup-image")) {
			$(".popup-image__image").attr("src", "");
		}
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});


// Article share
$(".article__share-toggler").on("click", function () {
	$(".article__share-toggler").not(this).siblings(".article__share-list").removeClass("active");
	$(this).siblings(".article__share-list").toggleClass("active");
});


// FAQ
$(".faq-table__item-toggler").on("click", function () {
	$(".faq-table__item-toggler").not(this).removeClass("active");
	$(".faq-table__item-toggler").not(this).siblings(".faq-table__item-answer").slideUp();
	$(this).toggleClass("active");
	$(this).siblings(".faq-table__item-answer").slideToggle();
});


// Range
// const rangeInputs = document.querySelectorAll('.form__range-slider')
// const numberInputs = document.querySelector('.form__range-input')
// let isRTL = document.documentElement.dir === 'rtl'

// function handleInputChange(e) {
// 	let target = e.target
// 	if (e.target.type !== 'range') {
// 		target = document.getElementById('range')
// 	}
// 	const min = target.min
// 	const max = target.max
// 	const val = target.value
// 	let percentage = (val - min) * 100 / (max - min)
// 	if (isRTL) {
// 		percentage = (max - val)
// 	}

// 	target.style.backgroundSize = percentage + '% 100%'
// }

// rangeInputs.forEach(input => {
// 	input.addEventListener('input', handleInputChange)
// })

// Handle element change, check for dir attribute value change
function callback(mutationList, observer) {
	mutationList.forEach(function (mutation) {
		if (mutation.type === 'attributes' && mutation.attributeName === 'dir') {
			isRTL = mutation.target.dir === 'rtl'
		}
	})
}

// Listen for body element change
const observer = new MutationObserver(callback)
observer.observe(document.documentElement, { attributes: true })


// SWIPER
let el_BlogTheme = document.querySelector('.blog-slider__table-container')
if (el_BlogTheme) {
	var blogThemeSlider = new Swiper('.blog-slider__table-container', {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			1360: {
				slidesPerView: 3,
				spaceBetween: 24
			},
		},
		navigation: {
			nextEl: '.blog-slider__nav-btn--next',
			prevEl: '.blog-slider__nav-btn--prev'
		}
	});
}

let el_Portfolio = document.querySelector('.portfolio-slider__table-container')
if (el_Portfolio) {
	var portfolio = new Swiper('.portfolio-slider__table-container', {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1360: {
				slidesPerView: 2,
				spaceBetween: 24
			},
		},
		navigation: {
			nextEl: '.portfolio-slider__nav-btn--next',
			prevEl: '.portfolio-slider__nav-btn--prev'
		}
	});
}

let el_Partners = document.querySelector('.partners__container')
if (el_Partners) {
	var partnersSlider = new Swiper('.partners__container', {
		modules: [Navigation],
		slidesPerView: "auto",
		navigation: {
			nextEl: '.partners__nav-btn--next',
			prevEl: '.partners__nav-btn--prev'
		}
	});
}

let el_AuthorSerts = document.querySelector('.author-certs__slider')
if (el_AuthorSerts) {
	var authorSertsSlider = new Swiper('.author-certs__slider', {
		modules: [Navigation],
		slidesPerView: "auto",
		spaceBetween: 16,
		breakpoints: {
			768: {
				spaceBetween: 24
			},
			1360: {
				spaceBetween: 32
			},
		},
		navigation: {
			nextEl: '.author-certs__nav-btn--next',
			prevEl: '.author-certs__nav-btn--prev'
		}
	});
}

// Copy article url
$(".article__share-btn--copy").on("click", function () {
	let url = document.location.href;
	navigator.clipboard.writeText(url);
	$(this).siblings(".article__share-copied").addClass("active");
	setTimeout(() => {
		$(this).siblings(".article__share-copied").removeClass("active");
	}, 2000);
});


// Suggestions
$(".form__input-address").each(function () {
	$(this).suggestions({
		token: "9b7035e8a3a10d58dcee12c839033bb60c01d340",
		type: "ADDRESS",
		/* Вызывается, когда пользователь выбирает одну из подсказок */
		onSelect: function (suggestion) {
			let regionCode = suggestion.data.region_kladr_id.substr(0, 2)
			let input = document.getElementById('regionCode')
			input.value = regionCode
			//- console.log(suggestion)
			evaluation.object = suggestion;
		}
	})
});

$(".form__input-email").each(function () {
	$(this).suggestions({
		token: "9b7035e8a3a10d58dcee12c839033bb60c01d340",
		type: "EMAIL",
		/* Вызывается, когда пользователь выбирает одну из подсказок */
		onSelect: function (suggestion) {
			//- console.log(suggestion);
		}
	})
});


// tel
function parsePhoneNumber() {
	var num = this.value
		.replace(/^(8|7|\+7\(7|\+7)/, "")
		.replace(/\D/g, "")
		.split(/(?=.)/),
		i = num.length
	if (0 <= i) num.unshift("+7")
	if (1 <= i) num.splice(1, 0, " (")
	if (4 <= i) num.splice(5, 0, ") ")
	if (7 <= i) num.splice(9, 0, "-")
	if (9 <= i) num.splice(12, 0, "-")
	if (11 <= i) num.splice(15, num.length - 15)
	this.value = num.join("")
}

$.fn.formatPnoneNumber = function () {
	return this.each(function () {
		$(this).on("input", parsePhoneNumber)
	})
}

$(".form__input-tel").formatPnoneNumber();


// Popup image
$("[data-popup-open='popup-image']").on("click", function (e) {
	e.preventDefault();
	let dataImageSrc = $(this).attr("href");
	$(".popup-image__image").attr("src", dataImageSrc);
});

$(".popup-image__close").on("click", function (e) {
	$(".popup-image__image").attr("src", "");
});
